import constate from 'constate'
import { useParams } from 'react-router'
import { useGetOnboardingRecordQuery } from '@/features/onboarding/onboarding.api.ts'

export const [OnboardingRecordDetailsProvider, useOnboardingRecordDetails] = constate(() => {
  const { onboardingRecordId } = useParams() as unknown as { onboardingRecordId: number }
  const { data, refetch, isFetching, error } = useGetOnboardingRecordQuery({
    id: onboardingRecordId,
  }, {
    skip: !onboardingRecordId,
  })

  return {
    data: data?.details,
    refetch,
    probationRecordId: data?.probationRecordId,
    workableRecord: data?.workableRecord,
    workableDocuments: data?.workableDocuments,
    sectionSummaries: data?.sectionSummaries || [],
    isFetching,
    error,
  }
})